module.exports = __webpack_public_path__ + "static/media/gameCityBuilder.a76a462a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameCityBuilder.png
// module id = 2652
// module chunks = 0